/* PLAKTON · pk-header.js — cabecera flotante y menú móvil */
(function () {
  'use strict';
  function init(root) {
    var hdr = root.querySelector('[data-pk-hdr]') || (root.matches && root.matches('[data-pk-hdr]') ? root : null);
    if (!hdr || hdr.dataset.pkReady) return;
    hdr.dataset.pkReady = '1';
    var bar = hdr.querySelector('[data-pk-hdr-bar]');
    var tops = hdr.querySelectorAll('[data-pk-hdr-top]');
    var panels = hdr.querySelectorAll('[data-pk-hdr-panel]');
    var current = -1, closeT = null;
    var desk = window.matchMedia('(min-width: 1025px)');

    /* Altura para el espacio bajo la cabecera */
    /* Siempre con la cinta a tamaño completo: si se mide con la cinta recogida (al hacer scroll,
       o cuando el móvil esconde su barra y dispara «resize»), al volver arriba el menú pisaba el banner */
    var tick = hdr.querySelector('.pk-hdr__tick');
    var lastW = 0;
    function measure(force) {
      if (!force && window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      if (hdr.classList.contains('is-open')) return;
      var tickNow = tick ? tick.getBoundingClientRect().height : 0;
      var tickFull = tick ? tick.scrollHeight : 0;
      var gapTop = parseFloat(getComputedStyle(hdr).top) || 0;
      var h = bar.getBoundingClientRect().height - tickNow + tickFull + gapTop * 2;
      document.documentElement.style.setProperty('--pk-hdr-h', Math.round(h) + 'px');
    }
    window.addEventListener('resize', function () { measure(false); });
    window.addEventListener('load', function () { measure(true); });
    measure(true);

    /* Cinta oculta al hacer scroll */
    var ticking = false;
    function onScroll() {
      ticking = false;
      hdr.classList.toggle('is-scrolled', window.scrollY > 60);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    /* Paneles */
    function setPreview(panel, a) {
      if (!a) return;
      var box = panel.querySelector('[data-pk-hdr-preview]');
      panel.querySelectorAll('[data-pk-hdr-item]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
      if (!box) return;
      var wrap = box.querySelector('.pk-hdr__pimg');
      var src = a.getAttribute('data-img');
      box.href = a.href;
      box.querySelector('[data-pk-hdr-peb]').textContent = a.getAttribute('data-eb') || '';
      box.querySelector('[data-pk-hdr-pt]').textContent = a.textContent.replace('→', '').trim();
      panel.querySelectorAll('[data-pk-hdr-item]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
      var old = wrap.querySelector('img');
      if (!src || (old && old.getAttribute('src') === src)) return;
      var img = new Image();
      img.alt = ''; img.decoding = 'async'; img.src = src;
      img.style.objectPosition = a.getAttribute('data-focal') || '50% 50%';
      img.onload = function () {
        wrap.appendChild(img);
        if (old) { old.classList.add('is-leaving'); setTimeout(function () { old.remove(); }, 350); }
      };
    }
    function open(i) {
      clearTimeout(closeT);
      if (current === i) return;
      current = i;
      panels.forEach(function (p) {
        var on = Number(p.getAttribute('data-pk-hdr-panel')) === i;
        p.hidden = !on;
        p.classList.toggle('is-in', on);
        if (on && !p.dataset.pkPrev) { p.dataset.pkPrev = '1'; setPreview(p, p.querySelector('[data-pk-hdr-item]')); }
      });
      tops.forEach(function (t) { t.setAttribute('aria-expanded', Number(t.getAttribute('data-pk-hdr-top')) === i ? 'true' : 'false'); });
      hdr.classList.add('is-open');
    }
    function close() {
      current = -1;
      hdr.classList.remove('is-open');
      tops.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { if (current === -1) panels.forEach(function (p) { p.hidden = true; p.classList.remove('is-in'); }); }, 450);
    }
    tops.forEach(function (t) {
      var i = Number(t.getAttribute('data-pk-hdr-top'));
      t.addEventListener('mouseenter', function () { if (desk.matches) open(i); });
      t.addEventListener('focus', function () { if (desk.matches) open(i); });
    });
    hdr.querySelectorAll('[data-pk-hdr-plain], .pk-hdr__logo, .pk-hdr__utils').forEach(function (el) { el.addEventListener('mouseenter', function () { if (desk.matches) closeT = setTimeout(close, 120); }); });
    bar.addEventListener('mouseleave', function () { closeT = setTimeout(close, 180); });
    bar.addEventListener('mouseenter', function () { if (current !== -1) clearTimeout(closeT); });
    hdr.querySelectorAll('[data-pk-hdr-item]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { setPreview(a.closest('[data-pk-hdr-panel]'), a); });
      a.addEventListener('focus', function () { setPreview(a.closest('[data-pk-hdr-panel]'), a); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closeSheet(); } });

    /* Contador de la cesta: rebote al cambiar, oculto si está vacía */
    var cnt = hdr.querySelector('.pk-hdr__countnum');
    if (cnt && 'MutationObserver' in window) {
      var last = cnt.textContent.trim();
      new MutationObserver(function () {
        var v = cnt.textContent.trim(); if (v === last) return; last = v;
        var link = cnt.closest('.pk-hdr__cart'); link.classList.toggle('has-items', v !== '0' && v !== '');
        link.classList.remove('is-bump'); void link.offsetWidth; link.classList.add('is-bump');
      }).observe(cnt, { childList: true, characterData: true, subtree: true });
    }

    /* Selector de idioma */
    var lw = hdr.querySelector('[data-pk-lang]');
    if (lw) {
      var lb = lw.querySelector('[data-pk-lang-btn]'), lp = lw.querySelector('[data-pk-lang-pop]');
      document.body.appendChild(lp);
      function lpClose() { lp.classList.remove('is-open'); lb.setAttribute('aria-expanded', 'false'); setTimeout(function () { if (!lp.classList.contains('is-open')) lp.hidden = true; }, 220); }
      lb.addEventListener('click', function (e) {
        e.stopPropagation();
        if (lp.classList.contains('is-open')) { lpClose(); return; }
        close();
        var r = lb.getBoundingClientRect();
        lp.hidden = false;
        lp.style.top = (r.bottom + 10) + 'px';
        lp.style.left = Math.max(8, Math.min(window.innerWidth - 248, r.right - 240)) + 'px';
        requestAnimationFrame(function () { lp.classList.add('is-open'); });
        lb.setAttribute('aria-expanded', 'true');
        var a = lp.querySelector('.is-active') || lp.querySelector('button'); if (a) a.focus();
      });
      document.addEventListener('click', function (e) { if (!lp.hidden && !lp.contains(e.target)) lpClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lp.hidden) { lpClose(); lb.focus(); } });
      window.addEventListener('scroll', function () { if (!lp.hidden) lpClose(); }, { passive: true });
    }

    /* Menú móvil */
    var sheet = document.querySelector('[data-pk-hdr-sheet]');
    var burger = hdr.querySelector('[data-pk-hdr-burger]');
    function openSheet() {
      if (!sheet) return;
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.classList.add('pk-hdr-lock');
      burger.setAttribute('aria-expanded', 'true');
      var c = sheet.querySelector('[data-pk-hdr-close]'); if (c) c.focus();
    }
    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('pk-hdr-lock');
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { sheet.hidden = true; }, 320);
    }
    if (burger) burger.addEventListener('click', openSheet);
    if (sheet) {
      sheet.querySelectorAll('[data-pk-hdr-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
      var tabs = sheet.querySelectorAll('[data-pk-hdr-tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-pk-hdr-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          sheet.querySelectorAll('[data-pk-hdr-mpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-pk-hdr-mpanel') !== i; });
        });
      });
    }
  }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
